import dashboard from './dashboard';
import major from './major';
import system from './system';

// ===========================|| MENU ITEMS ||=========================== //

const menuItems = {
    items: [dashboard, major, system]
};

export default menuItems;
